var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#EBF3D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.08386V11.5459V11.6359V11.5459C7 12.8199 7.55588 13.9479 8.41776 14.678C8.83918 15.035 9.11765 15.517 9.11765 16.052V23.5001C9.11765 24.3281 9.82918 25.0001 10.7059 25.0001C11.5826 25.0001 12.2941 24.3281 12.2941 23.5001V16.052C12.2941 15.517 12.5726 15.035 12.994 14.678C13.8559 13.9479 14.4118 12.8199 14.4118 11.5459V7.08386V11.5459",
    stroke: "#8BAA36",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7051 12.0001V7",
    stroke: "#8BAA36",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9992 8.05153C24.9992 7.49952 24.5248 7.05151 23.9404 7.05151H22.8815C21.1271 7.05151 19.7051 8.39453 19.7051 10.0515V16.0516C19.7051 17.3556 20.5913 18.4546 21.8227 18.8677V23.4997C21.8227 24.3277 22.5343 24.9997 23.411 24.9997C24.2877 24.9997 24.9992 24.3277 24.9992 23.4997V19.0517V8.05153Z",
    stroke: "#8BAA36",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3abf97259d1bfe7ec469ab5cda93cf20.svg";
export { ForwardRef as ReactComponent };